var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSingle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.301 2.43C.301 1.53 1.031.8 1.93.8h9.17V15.2h-9.17A1.628 1.628 0 01.301 13.57V2.429z",
    stroke: "currentColor",
    strokeWidth: 0.603
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.301,
    y: 0.801,
    width: 18.397,
    height: 14.397,
    rx: 1.628,
    stroke: "currentColor",
    strokeWidth: 0.603
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxOSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuMzAxNDE4IDIuNDI5MDhDMC4zMDE0MTggMS41MzAxNSAxLjAzMDE1IDAuODAxNDE4IDEuOTI5MDggMC44MDE0MThIMTEuMDk4NlYxNS4xOTg2SDEuOTI5MDhDMS4wMzAxNSAxNS4xOTg2IDAuMzAxNDE4IDE0LjQ2OTkgMC4zMDE0MTggMTMuNTcwOVYyLjQyOTA4WiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMC42MDI4MzciLz4KPHJlY3QgeD0iMC4zMDE0MTgiIHk9IjAuODAxNDE4IiB3aWR0aD0iMTguMzk3MiIgaGVpZ2h0PSIxNC4zOTcyIiByeD0iMS42Mjc2NiIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMC42MDI4MzciLz4KPC9zdmc+Cg==";
export { SvgSingle as ReactComponent };